import { PropsWithClassName } from '~types/Props.types';

export enum DropdownMods {
  ArrowBlue = 'arrowBlue',
  Error = 'error',
  InheritedFont = 'inheritedFont',
  Right = 'right',
  Top = 'top',
}

export type DropdownValue = string;

export type DropdownItem<Values> = {
  value: Values;
  disabled?: boolean;
  placeholder?: boolean;
  text?: string;
};

export type DropdownProps<Values extends DropdownValue = DropdownValue> =
  PropsWithClassName<{
    value: Values;
    values: DropdownItem<Values>[] | Values[];
    disabled?: boolean;
    label?: string;
    listMaxHeight?: number;
    mods?: DropdownMods[];
    onBlur?(): void;
    onChange?(value: Values): void;
  }>;
